// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.meetings-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
}

.meetings-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.meetings-header h1 {
  margin: 0 0 8px;
  color: var(--primary-blue);
  font-size: 28px;
}

.meetings-header p {
  margin: 0;
  color: var(--text-secondary);
}

.meetings-filters {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.filter-btn {
  padding: 8px 16px;
  background: var(--white);
  border: 2px solid var(--light-gray);
  border-radius: 20px;
  color: var(--text-secondary);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.filter-btn:hover {
  background: var(--light-gray);
}

.filter-btn.active {
  background: var(--primary-blue);
  color: var(--white);
  border-color: var(--primary-blue);
}

.meetings-content {
  background: var(--white);
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.meetings-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.meeting-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border: 2px solid var(--light-gray);
  border-radius: 12px;
  transition: all 0.2s;
}

.meeting-card:hover {
  box-shadow: 0 4px 12px rgba(30, 58, 138, 0.15);
  border-color: var(--secondary-blue);
}

.meeting-info {
  display: flex;
  gap: 20px;
  flex: 1 1;
}

.meeting-date-time {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  padding: 12px;
  background: var(--primary-blue);
  border-radius: 8px;
  color: var(--white);
}

.meeting-date {
  font-size: 14px;
  font-weight: 600;
}

.meeting-time {
  font-size: 12px;
  opacity: 0.9;
}

.meeting-details h3 {
  margin: 0 0 8px;
  color: var(--text-primary);
  font-size: 18px;
}

.meeting-description {
  margin: 0 0 8px;
  color: var(--text-secondary);
  font-size: 14px;
}

.meeting-meta {
  display: flex;
  gap: 12px;
  align-items: center;
  font-size: 12px;
  color: var(--text-secondary);
}

.host-badge {
  padding: 2px 8px;
  background: var(--primary-yellow);
  color: var(--text-primary);
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
}

.meeting-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
}

.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.status-badge.scheduled {
  background: var(--secondary-blue);
  color: var(--white);
}

.status-badge.in-progress {
  background: var(--primary-yellow);
  color: var(--text-primary);
}

.status-badge.completed {
  background: var(--success);
  color: var(--white);
}

.status-badge.cancelled {
  background: var(--secondary-red);
  color: var(--white);
}

.btn-join {
  padding: 8px 20px;
  background: var(--primary-blue);
  color: var(--white);
  text-decoration: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s;
}

.btn-join:hover {
  background: var(--dark-blue);
}

.btn-cancel {
  padding: 8px 16px;
  background: var(--secondary-red);
  color: var(--white);
  border: none;
  border-radius: 6px;
  font-size: 12px;
  cursor: transition;
}

.btn-cancel:hover {
  background: var(--primary-red);
}

.no-meetings {
  text-align: center;
  padding: 60px 20px;
}

.no-meetings p {
  color: var(--text-secondary);
  margin-bottom: 20px;
}

.meetings-loading {
  text-align: center;
  padding: 60px 20px;
  color: var(--text-secondary);
}

.error-message {
  background: var(--light-red);
  border: 1px solid var(--secondary-red);
  color: var(--primary-red);
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.btn-primary {
  padding: 10px 20px;
  background: var(--primary-blue);
  color: var(--white);
  text-decoration: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-primary:hover {
  background: var(--dark-blue);
}

.btn-secondary {
  padding: 10px 20px;
  background: var(--secondary-red);
  color: var(--white);
  text-decoration: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-secondary:hover {
  background: var(--primary-red);
}

@media (max-width: 600px) {
  .meeting-card {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .meeting-actions {
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    margin-top: 16px;
  }
  
  .meeting-info {
    flex-direction: column;
  }
  
  .meeting-date-time {
    flex-direction: row;
    gap: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Meetings.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mCAAmC;EACnC,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,8CAA8C;EAC9C,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,sCAAsC;EACtC,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;AACF","sourcesContent":[".meetings-page {\r\n  max-width: 900px;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n}\r\n\r\n.meetings-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.meetings-header h1 {\r\n  margin: 0 0 8px;\r\n  color: var(--primary-blue);\r\n  font-size: 28px;\r\n}\r\n\r\n.meetings-header p {\r\n  margin: 0;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.meetings-filters {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.filter-btn {\r\n  padding: 8px 16px;\r\n  background: var(--white);\r\n  border: 2px solid var(--light-gray);\r\n  border-radius: 20px;\r\n  color: var(--text-secondary);\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.filter-btn:hover {\r\n  background: var(--light-gray);\r\n}\r\n\r\n.filter-btn.active {\r\n  background: var(--primary-blue);\r\n  color: var(--white);\r\n  border-color: var(--primary-blue);\r\n}\r\n\r\n.meetings-content {\r\n  background: var(--white);\r\n  border-radius: 12px;\r\n  padding: 20px;\r\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.meetings-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.meeting-card {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 20px;\r\n  border: 2px solid var(--light-gray);\r\n  border-radius: 12px;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.meeting-card:hover {\r\n  box-shadow: 0 4px 12px rgba(30, 58, 138, 0.15);\r\n  border-color: var(--secondary-blue);\r\n}\r\n\r\n.meeting-info {\r\n  display: flex;\r\n  gap: 20px;\r\n  flex: 1;\r\n}\r\n\r\n.meeting-date-time {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 100px;\r\n  padding: 12px;\r\n  background: var(--primary-blue);\r\n  border-radius: 8px;\r\n  color: var(--white);\r\n}\r\n\r\n.meeting-date {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n\r\n.meeting-time {\r\n  font-size: 12px;\r\n  opacity: 0.9;\r\n}\r\n\r\n.meeting-details h3 {\r\n  margin: 0 0 8px;\r\n  color: var(--text-primary);\r\n  font-size: 18px;\r\n}\r\n\r\n.meeting-description {\r\n  margin: 0 0 8px;\r\n  color: var(--text-secondary);\r\n  font-size: 14px;\r\n}\r\n\r\n.meeting-meta {\r\n  display: flex;\r\n  gap: 12px;\r\n  align-items: center;\r\n  font-size: 12px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.host-badge {\r\n  padding: 2px 8px;\r\n  background: var(--primary-yellow);\r\n  color: var(--text-primary);\r\n  border-radius: 10px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n}\r\n\r\n.meeting-actions {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n  gap: 10px;\r\n}\r\n\r\n.status-badge {\r\n  display: inline-block;\r\n  padding: 4px 12px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n}\r\n\r\n.status-badge.scheduled {\r\n  background: var(--secondary-blue);\r\n  color: var(--white);\r\n}\r\n\r\n.status-badge.in-progress {\r\n  background: var(--primary-yellow);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.status-badge.completed {\r\n  background: var(--success);\r\n  color: var(--white);\r\n}\r\n\r\n.status-badge.cancelled {\r\n  background: var(--secondary-red);\r\n  color: var(--white);\r\n}\r\n\r\n.btn-join {\r\n  padding: 8px 20px;\r\n  background: var(--primary-blue);\r\n  color: var(--white);\r\n  text-decoration: none;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.btn-join:hover {\r\n  background: var(--dark-blue);\r\n}\r\n\r\n.btn-cancel {\r\n  padding: 8px 16px;\r\n  background: var(--secondary-red);\r\n  color: var(--white);\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 12px;\r\n  cursor: transition;\r\n}\r\n\r\n.btn-cancel:hover {\r\n  background: var(--primary-red);\r\n}\r\n\r\n.no-meetings {\r\n  text-align: center;\r\n  padding: 60px 20px;\r\n}\r\n\r\n.no-meetings p {\r\n  color: var(--text-secondary);\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.meetings-loading {\r\n  text-align: center;\r\n  padding: 60px 20px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.error-message {\r\n  background: var(--light-red);\r\n  border: 1px solid var(--secondary-red);\r\n  color: var(--primary-red);\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.btn-primary {\r\n  padding: 10px 20px;\r\n  background: var(--primary-blue);\r\n  color: var(--white);\r\n  text-decoration: none;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  border: none;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.btn-primary:hover {\r\n  background: var(--dark-blue);\r\n}\r\n\r\n.btn-secondary {\r\n  padding: 10px 20px;\r\n  background: var(--secondary-red);\r\n  color: var(--white);\r\n  text-decoration: none;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  border: none;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.btn-secondary:hover {\r\n  background: var(--primary-red);\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .meeting-card {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n  \r\n  .meeting-actions {\r\n    flex-direction: row;\r\n    width: 100%;\r\n    justify-content: space-between;\r\n    margin-top: 16px;\r\n  }\r\n  \r\n  .meeting-info {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .meeting-date-time {\r\n    flex-direction: row;\r\n    gap: 10px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
